/**
 * Фильтры реестра обращений граждан
 */
export interface IAppealFilters {
  search: string
  numbers: number[]
  topic: string[]
  status: string[]
  channels: string[]
  created_from: string | null
  created_to: string | null
  /** true — только новые, без отвеченных (переключатель «Скрыть отвеченные»), null — все */
  is_actual: boolean | null
}

/**
 * Получение пустого состояния фильтров по умолчанию
 */
export function getEmptyAppealFilters(): IAppealFilters {
  return {
    search: '',
    numbers: [],
    topic: [],
    status: [],
    channels: [],
    created_from: null,
    created_to: null,
    is_actual: null,
  }
}
